import { render, staticRenderFns } from "./TodayReservationsPage.vue?vue&type=template&id=82c7965c&scoped=true&"
import script from "./TodayReservationsPage.vue?vue&type=script&lang=js&"
export * from "./TodayReservationsPage.vue?vue&type=script&lang=js&"
import style0 from "./TodayReservationsPage.vue?vue&type=style&index=0&id=82c7965c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c7965c",
  null
  
)

export default component.exports